import { useEffect } from "react";

/**
 * SEO Component for dynamic meta tags management
 * Works with React 19 without external dependencies
 */
const SEO = ({
  title = "Ceekay Enterprise - Industrial Chemical Suppliers India | Importer & Distributor",
  description = "Leading industrial chemical importer and supplier in India since 1992. Buy high-quality borates, sulfates, nitrates, and specialty chemicals. Competitive pricing, fast delivery across India.",
  keywords = "industrial chemicals India, chemical importer, borates supplier, chemical distributor, Ceekay Enterprise",
  canonical = "",
  ogImage = "/images/chemical-bags.jpg",
  ogType = "website",
  schema = null,
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", description);

    // Update or create meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.setAttribute("name", "keywords");
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", keywords);

    // Update or create canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!canonicalLink) {
        canonicalLink = document.createElement("link");
        canonicalLink.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute("href", canonical);
    } else if (canonicalLink) {
      canonicalLink.setAttribute("href", window.location.href);
    }

    // Open Graph meta tags
    const ogTags = {
      "og:title": title,
      "og:description": description,
      "og:image": ogImage,
      "og:type": ogType,
      "og:url": canonical || window.location.href,
    };

    Object.entries(ogTags).forEach(([property, content]) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("property", property);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    });

    // Twitter Card meta tags
    const twitterTags = {
      "twitter:card": "summary_large_image",
      "twitter:title": title,
      "twitter:description": description,
      "twitter:image": ogImage,
    };

    Object.entries(twitterTags).forEach(([name, content]) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    });

    // Add JSON-LD schema if provided
    if (schema) {
      let schemaScript = document.querySelector('script[type="application/ld+json"]');
      if (schemaScript) {
        schemaScript.remove();
      }
      schemaScript = document.createElement("script");
      schemaScript.type = "application/ld+json";
      schemaScript.text = JSON.stringify(schema);
      document.head.appendChild(schemaScript);
    }

    // Cleanup function (optional, but good practice)
    return () => {
      // Schema script cleanup will happen on next render anyway
    };
  }, [title, description, keywords, canonical, ogImage, ogType, schema]);

  return null; // This component doesn't render anything
};

export default SEO;

